// Project Configuration
export const PROJECT_CONFIG = {
  project: {
    name: "Shree Mangal Dev Grah Mandir",
    shortName: "Mangal Dev Mandir",
    description: "Shree Mangal Grah Temple of Amalner is one of the India's rarest temples which is dedicated to Mangal (Planet Mars), where all wishes of devotees are fulfilled. Explore the Mandir area.",
    type: "Mandir",
    address: "Chopda Road, Amalner - 425401, Dist Jalgaon (M.S.) India",
    phone: "+91 8348606060 / +91 8348707070 / +91 8348808080",
    email: "mangalgrahamandir@gmail.com",
    trust: "Shree Mangal Grah Seva Sanstha"
  },
  assistant: {
    name: "",
    description: "",
    capabilities: [
      "Navigate Matterport 3D space",
      "Answer questions about", 
      "Access detailed facility documentation via PDF context",
      "Spatial awareness and context"
    ]
  },
  features: {
    chatEnabled: false,
    showMatterportLogo: false,
    showMatterportSearch: false,
    showMatterportSpaceInfo: false,
    videosEnabled: true,
    showShareButton: false,
    showVRButton: false,
    showFullscreenButton: false,
    showFooterHelp: false,
    locationQuickNavEnabled: true,
    // Accessibility: read-along captions driven by the per-stop narration
    // text in `public/config/navigationStopsGuide.json`. Segments follow
    // the real <audio> playhead exposed by audioService.
    readAlongCaptionsEnabled: true,
    // Kiosk mode: custom nav pointer + enforce one-step-at-a-time navigation
    kioskMode: false
  },
  i18n: {
    defaultLanguage: 'mr',
    supportedLanguages: [
      { code: 'mr', label: 'मराठी', abbr: 'मर' },
      { code: 'en', label: 'English', abbr: 'EN', displayLabel: 'English' },
      { code: 'hi', label: 'हिन्दी', abbr: 'हि' }
    ]
  },
  matterport: {
    sdk_version: "3.1",
    features: [
      "Tag-based navigation",
      "Spatial context tracking", 
      "Real-time position updates",
      "Quick navigation buttons"
    ]
  },
  ai: {
    model: "gpt-4",
    max_tokens: 1500,
    temperature: 0.7,
    functions: [
      "navigate_to_tag",
      "get_spatial_info"
    ]
  }
};

// Default suggestions for the chat
export const SUGGESTIONS = [
  "What are the abhishek timings?",
  "Tell me about Mangal Bhagwan",
  "Take me to the Garbhagriha",
  "What is the history of this temple?",
  "How can I register for Abhishek?",
  "Take me to the Tulsaee Udyan",
  "What services does the temple offer?",
  "Where is the Havan Kund?"
];

// Detect mobile / low-memory devices so we can disable the high-resolution
// panorama flag (`hr=1`). On phones — especially iOS Safari — high-res
// textures routinely exceed the WebGL memory budget and the iframe fails
// to load (welcome screen sticks on the spinner). Desktops/kiosks keep
// the crisp panoramas; phones fall back to the standard resolution.
const _isMobileDevice = (() => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  try {
    const ua = navigator.userAgent || '';
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet/i.test(ua)) return true;
    // Touch + small viewport is a strong mobile signal even when UA is spoofed.
    const hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints || 0) > 1;
    if (hasTouch && Math.min(window.innerWidth, window.innerHeight) <= 820) return true;
  } catch (_) { /* noop */ }
  return false;
})();

// Matterport configuration
export const MATTERPORT_CONFIG = {
  // showcase_url: "https://my.matterport.com/show?m=ifbwMbdpAP6&play=1&qs=1&brand=0&help=0",
  // showcase_url: "https://my.matterport.com/show/?m=2wQsmvJNzPm&play=1&qs=1&brand=0&help=0",
  // On mobile we additionally pass `dh=0` (skip dollhouse mesh download — it's
  // a multi-megabyte asset we never show on phones) and `qs=1` (quickstart:
  // skip the intro animation so the heavy texture upload happens before the
  // user has a chance to interact, reducing the window in which iOS can OOM
  // the tab).
  showcase_url: `/bundle/showcase.html?m=XyR7sbWsLFP&applicationKey=${process.env.REACT_APP_MATTERPORT_SDK_KEY || ''}&play=1${_isMobileDevice ? '&dh=0&qs=1' : '&hr=1'}&brand=0&help=0&tagNav=0&search=${PROJECT_CONFIG.features.showMatterportSearch ? '1' : '0'}&title=${PROJECT_CONFIG.features.showMatterportSpaceInfo ? '1' : '0'}`,  
  camera: {
    initialSweepId: '0phayedm8ki7b0d659ddghepa', // Mandir entrance — default view
    initialRotation: {
      pitch: 12.13, // Vertical rotation in degrees (-90 to 90)
      yaw: 119.95,  // Horizontal rotation in degrees
      roll: 0
    },
    transitionTime: 1000 // Time in milliseconds for camera rotation
  },
  sdk_script_url: "https://static.matterport.com/showcase-sdk/bootstrap/3.0.0-0-g0517b8d76c/sdk.js"
}; 
